import { ClientOnly } from '@wkda/styleguide';
import { Suspense, createContext, lazy, useContext, useEffect } from 'react';
import { useForm } from 'react-final-form';
import { useHistoryStackSelector } from '../FormsStateMachine/stateSelectors';
import { CarleadWizard } from './CarleadWizard';
import { SyncFormValuesGlobalStore } from './CarleadCreationFormStore';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadTimeTracking = /*#__PURE__*/lazy(() => import('./CarleadTimeTracking'));
export const MachineServiceContext = /*#__PURE__*/createContext(undefined);
export function useFormMachine() {
  // @ts-expect-error
  const context = useContext(MachineServiceContext);
  if (!context) {
    throw new Error('useFormMachine must be used within a CarleadCreationForm');
  }
  return context;
}
export function CarleadCreationForm(_ref) {
  let {
    children,
    carleadForm,
    options,
    submitHandler,
    topContent,
    bottomContent,
    machineService
  } = _ref;
  return /*#__PURE__*/_jsxs(MachineServiceContext.Provider, {
    value: machineService,
    children: [/*#__PURE__*/_jsx(ClientOnly, {
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(CarleadTimeTracking, {
          pageName: (options === null || options === void 0 ? void 0 : options.name) || 'StepCompound'
        })
      })
    }), /*#__PURE__*/_jsxs(CarleadWizard, {
      carleadForm: carleadForm,
      options: options,
      submitHandler: submitHandler,
      topContent: topContent,
      bottomContent: bottomContent,
      machineService: machineService,
      children: [/*#__PURE__*/_jsx(ResetFormErrors, {}), /*#__PURE__*/_jsx(SyncFormValuesGlobalStore, {}), children]
    })]
  });
}

/**
 * Clears the form submitFailed state if the context
 * stack changes (the state machine has transition to a new state)
 * this remove <FieldError /> from the screen
 * @returns null
 */
function ResetFormErrors() {
  const {
    getState,
    reset
  } = useForm();
  const changed = useHistoryStackSelector();
  useEffect(() => {
    const {
      values,
      submitFailed
    } = getState();
    if (submitFailed) {
      reset(values);
    }
  }, [changed, getState, reset]);
  return null;
}